import { render, staticRenderFns } from "./IconMappingTo.vue?vue&type=template&id=3cf01d2f&"
import script from "./IconMappingTo.vue?vue&type=script&lang=js&"
export * from "./IconMappingTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports